import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import type { ButtonProps } from "./Button";

export interface RevisionsButtonProps extends ButtonProps {
  onClick?: () => void;
}

export const RevisionsButton = ({
  className,
  onClick,
  ...rest
}: RevisionsButtonProps) => (
  <IconButton
    name="20-version-history"
    iconSize={20}
    buttonSize={28}
    className={className}
    tooltipText={t("settings.site.pages.builder.revisions.versions")}
    tooltipPosition="bottom"
    onClick={onClick}
    title={t("settings.site.pages.builder.revisions.title")}
    ariaLabel={t("settings.site.pages.builder.revisions.title")}
    data-testid="builder-ui-version-history-button"
    {...rest}
  />
);
